export default "__VITE_ASSET__VgiPIi2G__"